export const space = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48];
({
    1: space.xxs,
    2: space.xs,
    3: space.s,
    4: space.m,
    5: space.l,
    6: space.xl,
    7: space.xxl,
    8: space.xxxl,
    9: space.xxxxl, // 48px
} = space);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BhY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdGhlbWUvc3BhY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFjLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFFdEUsQ0FBQztJQUNDLENBQUMsRUFBRSxLQUFLLENBQUMsR0FBRztJQUNaLENBQUMsRUFBRSxLQUFLLENBQUMsRUFBRTtJQUNYLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNWLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNWLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNWLENBQUMsRUFBRSxLQUFLLENBQUMsRUFBRTtJQUNYLENBQUMsRUFBRSxLQUFLLENBQUMsR0FBRztJQUNaLENBQUMsRUFBRSxLQUFLLENBQUMsSUFBSTtJQUNiLENBQUMsRUFBRSxLQUFLLENBQUMsS0FBSyxFQUFFLE9BQU87Q0FDeEIsR0FBRyxLQUFLLENBQUMsQ0FBQyJ9